import script from "./AuthRecords2.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthRecords2.vue?vue&type=script&setup=true&lang=js"

import "./AuthRecords2.vue?vue&type=style&index=0&id=75baa992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75baa992"]])

export default __exports__